<template>
    <div id="BatchList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <!-- <template v-if="cantAccessPage === true"> -->
                <div class="page-name">Batch List</div>
                <div class="container-fluid">
                    <div class="admin-page-content batch-list">
                        <data-table-filter-config :moduleName="'batchList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'batchList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="listBatchTable"
                                    mode="remote"
                                    title="Batch"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                        enabled: true,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                        enabled: false,
                                    }">
                                    <div slot="selected-row-actions">
                                        <template v-if="canChangeStatus && showStatusBtn">
                                            <button type="button" class="btn btn-success" id="completeStatusBtn" v-on:click="changeStatus(1)">Complete</button>
                                            <button type="button" class="btn btn-danger" id="errorStatusBtn" v-on:click="changeStatus(2)">Error</button>
                                        </template>
                                        <button id="print" v-on:click.prevent="printStatement()" class="btn btn-primary">Download</button>
                                    </div>
                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'" class='align-center'>
                                              <a  v-if="(props.row.file_path != null && props.row.batch_status != 'Error')" href="javascript:void(0)" title="Download" v-on:click="download(props.row.file_path,props.row.batch_status)">
                                                  <i class="fp-download"></i>
                                              </a>
                                            </div>
                                            <div v-else>
                                              {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            <!-- </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template> -->
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import EventBus from "./event-bus";

import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';
import VueSSE from 'vue-sse'
Vue.use(VueSSE);
let msgServer;
export default {
    name: "BatchList",
    metaInfo() {
        return {title: "Batch List | " +process.env.COPYRIGHT_NAME}
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        userColumns:[],
        columns: [
            {
                label: 'Batch',
                field: 'batch',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Batch", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Description',
                field: 'module',
                filterable: true,
                hidden:false,
                fpFieldType:"text",
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Description", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Status',
                field: 'batch_status',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Message',
                field: 'message',
                fpFieldType:"text",
                filterable: false,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label: 'Created By',
                field: 'created_by',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Created By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Updated By',
                field: 'updated_by',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Updated By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Created At',
                field: 'created_at',
                fpFieldType:"date",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Created At", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Updated At',
                field: 'updated_at',
                fpFieldType:"date",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Updated At", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Actions',
                field: 'action',
                sortable: false,
                hidden:false,
            },
        ],
        rows: [],
        totalRecords: 0,
        loading:false,
        action:"list",
        canChangeStatus:false,
        showStatusBtn:false,
        batchIdArr:[]
    }),
    watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'list_batch') {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'change_batch_status') {
                        self.canChangeStatus = true;
                    }
                }
            }

        }

    },
    created: function() {

    },
    mounted: function() {
        var self = this;

        self.getPermissions();
    },
    beforeDestroy() {
        // Make sure to close the connection with the events server
        // when the component is destroyed, or we'll have ghost connections!
        msgServer.close();
    },
    methods: {
        cancelAll: function (cancelAll) {
          this.$refs.listBatchTable.unselectAllInternal();
        },
        fetchPendingBatch:function(){
            var self =  this;
            this.$sse(process.env.ROOT_API + '/pending-batch/check/',{ format: 'json' }) // or { format: 'plain' }
            .then(sse => {
                // Store SSE object at a higher scope
                msgServer = sse;

                // Listen for messages without a specified event
                sse.subscribe('', data => {
                    if ( data.status == "1" || data.status == "2" ) {
                        self.batchProcess = false;
                        self.loadList('batch');
                        sse.close();
                    }
                });

            })
            .catch(err => {
                // When this error is caught, it means the initial connection to the
                // events server failed.  No automatic attempts to reconnect will be made.
                console.error('Failed to connect to server', err);
            });

        },
        selectionChanged(param) {
            var self = this;
            var rowData = self.$refs['listBatchTable'].selectedRows;
            console.log(rowData);
            var statusArr = [];
            self.batchIdArr = [];
            self.showStatusBtn = false;
            if ( rowData.length > 0){
                for(var i = 0; i < rowData.length; i++){

                    statusArr.push(rowData[i].status);
                    if (rowData[i].status == 0) {
                        self.batchIdArr.push(rowData[i].id);
                    }

                }

                //check all values in array are equal or not
                const allEqual = arr => arr.every( v => v === arr[0] );
                var found = allEqual(statusArr);
                if (found) {
                    var selectedStatus = statusArr[0];
                    if (selectedStatus == 0) {
                        self.showStatusBtn = true;
                    }else{
                        self.showStatusBtn = false;
                        var message = "";
                        if (selectedStatus == 1) {
                            message = "Batch with status Completed status cannot be changed.";
                        }else{
                            message = "Batch with status Error status cannot be changed.";
                        }
                        // self.$swal('',message,'info');
                    }
                }else{
                    self.batchIdArr = [];
                    // self.$swal('',"To change status, Please select records with same status.",'info');
                }
                console.log(statusArr);
                console.log(self.batchIdArr);
            }
            if(param.selectedRows.length == 100) {
              EventBus.$emit('clear-selection', false);
            } else {
              EventBus.$emit('clear-all-flags', false);
            }
        },
        loadList(flag = '') {
            var self = this;
            self.loading = true;
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:self.action
            };
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/batch/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                        if (flag == ''){

                            self.fetchPendingBatch();

                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'batch-list')
                }
            });
        },
        changeStatus(statusValue) {
            var self = this;
            console.log(statusValue);

            self.loading = true;

            var fields = {
                arr:self.batchIdArr,
                status:statusValue
            }

            $.ajax({
                url: process.env.ROOT_API + "/batch/change-status",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    if (data.status == "success") {

                        self.$swal('','Batch Status Updated Successfully.','success');
                        self.loadList();
                    }
                },
                error: function (jqXHR, exception) {

                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'vendor-invoice-process-payment');
                }
            });
        },
        printStatement:function(){
            var self = this;
            self.$swal({
                title: 'Files with status completed will be downloaded!',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {
                    var data = this.$refs['listBatchTable'].selectedRows;
                    var self = this;
                    var use = [];
                    for (var i = 0; i < data.length; i++) {
                        if(this.$refs['listBatchTable'].selectedRows[i].batch_status == 'Completed'){
                            use.push(this.$refs['listBatchTable'].selectedRows[i].id)
                        }
                    }
                    if(use.length < 1){
                        this.$swal('','Please select completed record for download!!','info');
                        return;
                    }
                    $.ajax({
                        url: process.env.ROOT_API + "/batch-pdf/download",
                        type: "POST",
                        data: {ids:use},
                        headers: this.ajxHeaders,
                        success: function (data) {
                            if (data.status == 'success'){
                                var link = document.createElement('a');
                                document.body.appendChild(link);
                                link.href = data.content;
                                link.download = '';
                                link.target = "_blank";
                                link.click();
                            }
                            self.loadList();
                        },
                        error: function (jqXHR, exception) {
                            self.modalLoading = false;
                            self.reqeustSent = 0;
                            self.generateStatusCodeMessage(jqXHR,true,'email-report-invoice-template-download');
                        }
                    });
                }
            })
        },
         download: function(file_path,batch_status) {
              if(batch_status === "In Progress"){
                this.$swal('','Please wait, downloading process is in progress!!','info');
                return;
              }else {
                var save = document.createElement("a");
                save.href = file_path;
                save.download = file_path;
                save.target = "_blank";
                document.body.appendChild(save);
                save.click();
              }

            },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/BatchList.vue